import React, { useState } from 'react';
import { WhatWeBuildicon1, WhatWeBuildicon2, WhatWeBuildicon3, WhatWeBuildicon4, WhatWeBuildicon5, WhatWeBuildicon6 } from '../assets/images';

const SVCS = [
  {
    num: '01', name: 'Residential Building', text: "Custom homes and multi-unit residential projects built to your vision — quality craftsmanship from foundation to finish.",
    icon: <img src={WhatWeBuildicon1} alt="Residential Building" style={{ width: 48, height: 48, objectFit: 'contain' }} />
  },
  {
    num: '02', name: 'Commercial Building', text: "Office complexes, retail outlets, and industrial units — built on time, on budget, with zero compromise on quality.",
    icon: <img src={WhatWeBuildicon2} alt="Commercial Building" style={{ width: 48, height: 48, objectFit: 'contain' }} />
  },
  {
    num: '03', name: 'Tensile Structure', text: "Modern tensile canopies, membrane roofing, and shade structures designed for aesthetics, durability, and span.",
    icon: <img src={WhatWeBuildicon5} alt="Tensile Structure" style={{ width: 48, height: 48, objectFit: 'contain' }} />
  },
  {
    num: '04', name: 'PEB Structure', text: "Pre-engineered buildings delivering fast construction timelines, superior strength, and cost-effective industrial solutions.",
    icon: <img src={WhatWeBuildicon3} alt="PEB Structure" style={{ width: 48, height: 48, objectFit: 'contain' }} />
  },
  {
    num: '05', name: 'Project Management', text: "End-to-end oversight from concept to handover — ensuring every milestone, material, and man-hour meets our standard.",
    icon: <img src={WhatWeBuildicon4} alt="Project Management" style={{ width: 48, height: 48, objectFit: 'contain' }} />
  },
  {
    num: '06', name: 'Design & Consultancy', text: "Architectural planning, structural consultation, and site feasibility studies backed by decades of regional expertise.",
    icon: <img src={WhatWeBuildicon6} alt="Design & Consultancy" style={{ width: 48, height: 48, objectFit: 'contain' }} />
  },
];

function Card({ s }) {
  const [hov, setHov] = useState(false);
  return (
    <div className="reveal"
      onMouseEnter={() => setHov(true)}
      onMouseLeave={() => setHov(false)}
      style={{
        background: hov ? 'var(--dk2)' : 'var(--dk3)', padding: '2.5rem 2rem',
        position: 'relative', overflow: 'hidden', transition: 'background .3s', cursor: 'default'
      }}>
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(135deg,rgba(30,40,35,0.07),transparent)',
        opacity: hov ? 1 : 0, transition: 'opacity .3s', pointerEvents: 'none'
      }} />
      {s.icon}
      <div style={{
        fontFamily: 'var(--fh)', fontSize: '0.75rem', fontWeight: 600,
        letterSpacing: '0.2em', color: 'var(--gold)', marginBottom: '0.75rem', marginTop: '1.5rem'
      }}>{s.num}</div>
      <h3 style={{
        fontFamily: 'var(--fh)', fontSize: '1.5rem', fontWeight: 700,
        textTransform: 'uppercase', marginBottom: '1rem', lineHeight: 1.1
      }}>{s.name}</h3>
      <p style={{ fontSize: '0.9rem', fontWeight: 500, lineHeight: 1.7, color: 'var(--muted)' }}>{s.text}</p>
      <div style={{
        position: 'absolute', bottom: '1.5rem', right: '1.5rem', width: 32, height: 32,
        border: `1px solid ${hov ? 'var(--gold)' : '#1E2823'}`,
        background: hov ? 'var(--gold)' : 'transparent',
        display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all .3s'
      }}>
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none"
          stroke={hov ? 'var(--dk)' : 'var(--gold)'} strokeWidth="1.5">
          <path d="M2 7H12M8 3L12 7L8 11" />
        </svg>
      </div>
    </div>
  );
}

export default function Services() {
  return (
    <section id="services" style={{ position: 'relative', zIndex: 1, padding: '7rem 2rem', background: 'rgba(250,250,250,0.86)' }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="svc-intro" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', marginBottom: '4rem', alignItems: 'end' }}>
          <div className="reveal">
            <p style={{
              fontFamily: 'var(--fh)', fontSize: '1rem', fontWeight: 600,
              letterSpacing: '0.3em', textTransform: 'uppercase', color: 'var(--gold)', marginBottom: '1rem'
            }}>What We Build</p>
            <h2 style={{
              fontFamily: 'var(--fh)', fontSize: 'clamp(2.5rem,5vw,4rem)', fontWeight: 800,
              textTransform: 'uppercase', lineHeight: 1
            }}>Core <span style={{ color: 'var(--gold)' }}>Services</span></h2>
          </div>
          <p className="reveal" style={{ fontSize: '1.05rem', fontWeight: 500, lineHeight: 1.8, color: 'var(--lt)' }}>
            Muster Construct delivers end-to-end construction and consultancy solutions across Salem and Coimbatore — from single homes to large commercial and industrial complexes.
          </p>
        </div>
        <div className="svc-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 1, background: 'var(--mid)' }}>
          {SVCS.map((s) => <Card key={s.num} s={s} />)}
        </div>
      </div>
      <style>{`
        @media(max-width:900px){.svc-intro{grid-template-columns:1fr!important}.svc-grid{grid-template-columns:1fr!important}}
      `}</style>
    </section>
  );
}
